import React, { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import Logo from "../../../assets/images/logo.png";
import sidebarConfig from "./sidebarInterface";
import { IoMdArrowDropdown } from "react-icons/io";
import { motion } from "framer-motion";
import { BiMenuAltLeft } from "react-icons/bi";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const auth = JSON.parse(window.sessionStorage.getItem("auth"));
  const roles = JSON.parse(sessionStorage.getItem("#roles") || "{}");

  const navigate = useNavigate();
  const [endpoint, setApiEndpoint] = useState("");
  const [bgColor, setBgColor] = useState("");
  const [hoverbgColor, sethoverBgColor] = useState("");
  const [hovertextColor, sethoverTextColor] = useState("");
  const [hoverBorderColor, sethoverBorderColor] = useState("");
  const [color, setColor] = useState("");
  const [textColor, setTextColor] = useState("");
  const [textsColor, setTextsColor] = useState("");

  useEffect(() => {
    if (roles) {
      if (roles === "student") {
        setBgColor("bg-primary");
        setColor("border-blueColor");
        sethoverBorderColor("hover:border-blueColor");
        sethoverBgColor("hover:bg-primary");
        sethoverTextColor("hover:text-secondary");
        setTextColor("text-blueColor");
        setTextsColor("text-secondary");
        setApiEndpoint("/student-dashboard-endpoint");
      } else if (roles === "teacher") {
        setBgColor("bg-blueColor");
        setColor("border-primary");
        sethoverBgColor("hover:bg-blueColor");
        sethoverBorderColor("hover:border-primary");
        sethoverTextColor("hover:text-primary");
        setTextColor("text-primary");
        setTextsColor("text-blueColor");
        setApiEndpoint("/teacher-dashboard-endpoint");
      } else {
        setBgColor("bg-greenColor");
        setColor("border-primary");
        sethoverBgColor("hover:bg-greenColor");
        sethoverBorderColor("hover:border-primary");
        sethoverTextColor("hover:text-primary");
        setTextColor("text-primary");
        setTextsColor("text-greenColor");
        setApiEndpoint("/guest-dashboard-endpoint");
      }
    }
  }, [navigate, roles]);

  const [openMenu, setOpenMenu] = useState(null);

  const handleMenuClick = (index) => {
    setOpenMenu(openMenu === index ? null : index);
  };

  const submenuVariants = {
    hidden: { height: 0, opacity: 0 },
    visible: { height: "auto", opacity: 1 },
  };

  const sideBarVariants = {
    hidden: {
      width: 0,
      opacity: 0,
      rotateY: 90,
      transition: { duration: 0.5 },
    },
    visible: {
      width: "18rem",
      opacity: 1,
      rotateY: 0,
      transition: { duration: 0.5 },
    },
    exit: { width: 0, opacity: 0, rotateY: 90, transition: { duration: 0.5 } },
  };

  const location = useLocation();

  // Filter sidebarConfig based on user roles
  const filteredSidebarConfig = sidebarConfig.filter(
    (item) => !item.roles || item.roles.some((role) => roles.includes(role))
  );

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    // Redirect to the home page
    navigate("/");
  };

  return (
    <>
      <motion.div
        className="w-[14.5rem] bg-white z-50 sm:relative h-screen overflow-auto"
        initial="visible"
        animate={!isOpen ? "visible" : "hidden"}
        variants={sideBarVariants}
        transition={{ duration: 0.5, delay: 300 }}
      >
        <div
          className={`${
            isOpen ? "block" : "hidden"
          } sm:block text-white h-full`}
        >
          <div className="p-6 relative flex flex-col h-full justify-between">
            <main>
              <div className="flex justify-center pb-4">
                <div className="h-[115px] w-[115px]">
                  <img
                    src={Logo}
                    alt="logo"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <button
                onClick={toggleSidebar}
                className="focus:outline-none absolute top-10 right-2 sm:hidden block"
              >
                <BiMenuAltLeft size={24} color="#616161" />
              </button>
              <nav>
                {filteredSidebarConfig.map((item, index) => (
                  <div key={index}>
                    <NavLink
                      to={item.path}
                      className={({ isActive }) =>
                        `flex items-center px-2  py-3 my-3 ${hoverbgColor} ${hovertextColor} hover:border-r-4 ${hoverBorderColor} hover:font-bold rounded-md cursor-pointer ${
                          isActive
                            ? `${bgColor} ${textColor} font-semibold border-r-4 ${color}`
                            : `${textsColor}`
                        }`
                      }
                      onClick={() => handleMenuClick(index)}
                    >
                      {item.icon}
                      <span className="ml-4">{item.title}</span>
                      {item.subMenu && (
                        <IoMdArrowDropdown
                          className={`ml-auto transform transition-transform ${
                            openMenu === index ? "rotate-180" : ""
                          }`}
                          size={18}
                        />
                      )}
                    </NavLink>
                    {item.subMenu && openMenu === index && (
                      <motion.div
                        className="ml-8 overflow-hidden"
                        initial="hidden"
                        animate={openMenu === index ? "visible" : "hidden"}
                        variants={submenuVariants}
                        transition={{ duration: 0.3 }}
                      >
                        {item.subMenu.map((subItem, subIndex) => (
                          <NavLink
                            key={subIndex}
                            to={subItem.path}
                            className={({ isActive }) =>
                              `flex items-center p-2 my-2 hover:bg-[#E1E7FF] rounded-md hover:text-primary ${
                                isActive
                                  ? "bg-white text-primary font-semibold border-r-[3px] border-r-[#C4DAFE]"
                                  : "text-white"
                              }`
                            }
                          >
                            {subItem.title}
                          </NavLink>
                        ))}
                      </motion.div>
                    )}
                  </div>
                ))}
              </nav>
            </main>
            <div
              onClick={handleLogout}
              className="flex gap-2 cursor-pointer text-secondary md:text-lg items-center font-ManropeBold"
            >
              <Icon icon="ic:sharp-logout" width="20" height="20" />
              Logout
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default Sidebar;
